import React from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CurrentAndFutureCourtesies from "./CurrentAndFutureCourtesies";
import PastCourtesies from "./PastCourtesies";

const Courtesies = () => {

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="container">
        <CurrentAndFutureCourtesies />
        <PastCourtesies />
      </div>
    </LocalizationProvider>
  );
};

export default Courtesies;